import type {User} from "crqlar-react-common/dist/models/identity/user.model";
import {getScaledUrl, MediaSize} from "crqlar-react-common/dist/utils/media.util";

const AVATAR_COLORS = [
    "#2563EB",
    "#7C3AED",
    "#DB2777",
    "#DC2626",
    "#EA580C",
    "#A16207",
    "#15803D",
    "#0F766E",
    "#0891B2",
    "#0369A1",
    "#4F46E5",
    "#6D28D9",
];

export const getUserName = (user?: User) => (
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.email || "User"
);

const getAvatarInitials = (user?: User) => {
    const nameParts = [user?.firstName, user?.lastName]
        .map(part => part?.trim())
        .filter((part): part is string => Boolean(part));

    if (nameParts.length >= 2) {
        return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
    }

    const fallback = nameParts[0] || user?.email?.split("@")[0] || "?";
    return fallback.substring(0, 2).toUpperCase();
};

const getAvatarColor = (seed?: string) => {
    const value = seed || "default";
    let hash = 0;

    for (let index = 0; index < value.length; index += 1) {
        hash = value.charCodeAt(index) + ((hash << 5) - hash);
    }

    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getUserAvatar = (user?: User) => {
    const userName = getUserName(user);

    return {
        avatarColor: getAvatarColor(user?.id || user?.email || userName),
        avatarInitials: getAvatarInitials(user),
        avatarSrc: getScaledUrl(user?.avatar, MediaSize.MEDIUM_300, MediaSize.MEDIUM_300),
        userName,
    };
};
